<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section class="widget-section widget-section--filter flex no-wrap items-center q-mb-lg">
      <q-form ref="form" class="full-width">
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.id"
              label="Item Id"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
              :rules="[validateUuid]"
            ></q-input>
            <q-input
              v-model="filters.registrationId"
              label="Registration ID"
              outlined
              dense
              clearable
              class="full-width"
              :rules="[validateUuid]"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.name"
              label="Name"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-select
              v-model="filters.license"
              :options="[
                { label: 'Free', value: 'free' },
                { label: 'Enterprise', value: 'enterprise' },
                { label: 'China', value: 'china' },
              ]"
              emit-value
              map-options
              options-dense
              label="License"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="reloadTable"
            ></q-select>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-select
              v-model="filters.dns_enabled"
              :options="[
                { label: 'Enabled', value: true },
                { label: 'Disabled', value: false },
              ]"
              emit-value
              map-options
              options-dense
              label="DNS"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="reloadTable"
              @clear="
                () => {
                  filters.dns_enabled = undefined;
                }
              "
            ></q-select>
            <q-input
              v-model="filters.token_url"
              label="Token URL"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
        </div>
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.digitalService"
              label="Digital Service"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              class="full-width"
            ></q-input>
            <q-input
              v-model="filters.changeNumber"
              label="Change request number"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              class="full-width"
            ></q-input>
            <StatusSelect
              v-model="filters.status"
              @update:model-value="reloadTable"
              class="full-width"
              :options="['inprogress', 'completed', 'failed', 'removed']"
            />
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <DatePicker
              v-model="filters.dateFrom"
              @update:model-value="reloadTable"
              label="Created after"
              class="full-width"
              @clear="
                () => {
                  filters.dateFrom = undefined;
                }
              "
            />
            <DatePicker
              v-model="filters.dateTo"
              @update:model-value="reloadTable"
              label="Created before"
              class="full-width"
              @clear="
                () => {
                  filters.dateTo = undefined;
                }
              "
            />
          </div>
        </div>
      </q-form>
      <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
        <q-tooltip>Reset</q-tooltip>
      </q-icon>
    </section>
    <section class="widget-section widget-section--table">
      <ZonesTable
        ref="zonesTable"
        :rowsPerPageOptions="[20, 50, 100]"
        class="fixed-table"
        mode="list"
        :filters="filters"
      />
    </section>
  </q-page>
</template>

<script>
import DatePicker from './components/DatePicker.vue';
import StatusSelect from './components/StatusSelect.vue';
import ZonesTable from '@/shared/components/ZonesTable.vue';

export default {
  name: 'CloudflareZones',
  components: {
    StatusSelect,
    DatePicker,
    ZonesTable,
  },
  data() {
    return {
      loading: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: undefined,
        digitalService: undefined,
        infraService: undefined,
        changeNumber: undefined,
        name: undefined,
        license: undefined,
        dns_enabled: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    validateUuid(value) {
      const uuidRegex =
        // eslint-disable-next-line
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return value?.length ? uuidRegex.test(value) || 'Must be a valid UUID' : true;
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.reloadTable();
    },
    reloadTable() {
      this.$refs.zonesTable.reload();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      if (key === 'dns_enabled') {
        this.filters.dns_enabled =
          query.dns_enabled === 'true' ? true : query.dns_enabled === 'false' ? false : undefined;
      } else {
        this.filters[key] = query[key] || undefined;
      }
    });
    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.showBanner {
  .fixed-table {
    height: calc(100vh - 360px);
  }
}
.fixed-table {
  height: calc(100vh - 300px);
}
</style>

<style lang="scss">
.widget-section--table {
  margin-bottom: 0;
  padding: 16px 16px 5px;
  .external-dns-table thead tr:first-child th {
    background-color: white;
  }
}
.widget-section--filter {
  padding: 22px 16px 14px 12px;
}
.fixed-table {
  thead tr th {
    position: sticky;
    z-index: 99;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
  }

  /* prevent scrolling behind sticky top row on focus */
  tbody {
    /* height of all previous header rows */
    scroll-margin-top: 48px;
  }
}
</style>
